import {
    FETCH_PLANNING_ALERTS_REQUEST,
    FETCH_PLANNING_ALERTS_SUCCESS,
    FETCH_PLANNING_ALERTS_FAILURE,

    FETCH_PLANNING_ALERT_REQUEST,
    FETCH_PLANNING_ALERT_SUCCESS,
    FETCH_PLANNING_ALERT_FAILURE,

    CREATE_PLANNING_ALERT_REQUEST,
    CREATE_PLANNING_ALERT_SUCCESS,
    CREATE_PLANNING_ALERT_FAILURE,

    UPDATE_PLANNING_ALERT_REQUEST,
    UPDATE_PLANNING_ALERT_SUCCESS,
    UPDATE_PLANNING_ALERT_FAILURE,

    DELETE_PLANNING_ALERT_REQUEST,
    DELETE_PLANNING_ALERT_SUCCESS,
    DELETE_PLANNING_ALERT_FAILURE,

    SET_CURRENT_PLANNING_REPORT,

    FETCH_PLANNING_REPORT_REQUEST,
    FETCH_PLANNING_REPORT_SUCCESS,
    FETCH_PLANNING_REPORT_FAILURE,

    FETCH_PLANNING_ALERT_REPORTS_REQUEST,
    FETCH_PLANNING_ALERT_REPORTS_SUCCESS,
    FETCH_PLANNING_ALERT_REPORTS_FAILURE
} from './Types';

import axios from 'axios';
import { MAIN_MAP } from '../map/Constants';
import { addDrawFeature, setFitBoundsFromGeojson } from '../map/Actions';
import { commonDeleteAsync } from '../common/Actions';
import { openSnackbar } from '../ui/Actions';
import { PlanningAlerts } from '../user/userTypes';
import { PlanningAlertForm } from './planningTypes';

const CancelToken = axios.CancelToken;
let fetchPlanningAlertsSource, fetchPlanningAlertSource, createPlanningAlertSource, updatePlanningAlertSource, fetchPlanningReportSource, fetchPlanningAlertReportsSource;

const fetchPlanningAlerts = () => ({ type: FETCH_PLANNING_ALERTS_REQUEST });
const fetchPlanningAlertsSuccess = (planningAlerts: PlanningAlerts) => ({ type: FETCH_PLANNING_ALERTS_SUCCESS, planningAlerts });
const fetchPlanningAlertsError = (error: any) => ({ type: FETCH_PLANNING_ALERTS_FAILURE, error });
const fetchPlanningAlert = (id: number) => ({ type: FETCH_PLANNING_ALERT_REQUEST, id });
const fetchPlanningAlertSuccess = (id:number, planningAlert:PlanningAlertForm) => ({ type: FETCH_PLANNING_ALERT_SUCCESS, id, planningAlert });
const fetchPlanningAlertError = (id:number, error:any) => ({ type: FETCH_PLANNING_ALERT_FAILURE, id, error });
const createPlanningAlert = () => ({ type: CREATE_PLANNING_ALERT_REQUEST });
const createPlanningAlertSuccess = (planningAlert:PlanningAlertForm) => ({ type: CREATE_PLANNING_ALERT_SUCCESS, planningAlert });
const createPlanningAlertError = (error:any) => ({ type: CREATE_PLANNING_ALERT_FAILURE, error });

const updatePlanningAlert = (id:number) => ({ type: UPDATE_PLANNING_ALERT_REQUEST, id });
const updatePlanningAlertSuccess = (id:number, planningAlert:PlanningAlertForm) => ({ type: UPDATE_PLANNING_ALERT_SUCCESS, id, planningAlert });
const updatePlanningAlertError = (id:number, error:any) => ({ type: UPDATE_PLANNING_ALERT_FAILURE, id, error });

const deletePlanningAlert = (id:number) => ({ type: DELETE_PLANNING_ALERT_REQUEST, id });
const deletePlanningAlertSuccess = (id:number, planningAlert:PlanningAlertForm) => ({ type: DELETE_PLANNING_ALERT_SUCCESS, id, planningAlert });
const deletePlanningAlertError = (id:number, error:any) => ({ type: DELETE_PLANNING_ALERT_FAILURE, id, error });

const fetchPlanningReport = (id:number) => ({ type: FETCH_PLANNING_REPORT_REQUEST, id });
const fetchPlanningReportSuccess = (planningReport:PlanningAlertForm) => ({ type: FETCH_PLANNING_REPORT_SUCCESS, planningReport });
const fetchPlanningReportError = (id:number, error:any) => ({ type: FETCH_PLANNING_REPORT_FAILURE, id, error });

const fetchPlanningAlertReports = (id:number) => ({ type: FETCH_PLANNING_ALERT_REPORTS_REQUEST, id });
const fetchPlanningAlertReportsSuccess = (id:number, planningReports:PlanningAlertForm[]) => ({ type: FETCH_PLANNING_ALERT_REPORTS_SUCCESS, id, planningAlert: { planningReports: planningReports } });
const fetchPlanningAlertReportsError = (id:number, error:any) => ({ type: FETCH_PLANNING_ALERT_REPORTS_FAILURE, id, error });

export const fetchPlanningAlertsAsync = (projectId:number) => {
    return (dispatch: (arg0: { type: string; planningAlerts?: PlanningAlerts; error?: any; }) => void) => {
        dispatch(fetchPlanningAlerts());
        return axios.get(`/api/projects/${projectId}/planning_alerts`, {
            cancelToken: (fetchPlanningAlertsSource = axios.CancelToken.source()).token
        }).then(response => {
            dispatch(fetchPlanningAlertsSuccess(response.data));
        }).catch(error => {
            if (axios.isCancel(error)) {
                console.log('cancel');
            } else {
                dispatch(fetchPlanningAlertsError(error.response));
                console.error(error);
            }
        });
    };
};


export const fetchPlanningAlertAsync = (id:number) => {
    return (dispatch: (arg0: { type: string; id: number; planningAlert?: PlanningAlertForm; error?: any; }) => void) => {
        dispatch(fetchPlanningAlert(id));
        return axios.get(`/api/planning_alerts/${id}`, {
            cancelToken: (fetchPlanningAlertSource = axios.CancelToken.source()).token
        }).then(response => {
            // This assumes that once the planning alert loads the user wants to go to and show on the map
            // if(response.data.areaFacet.layerType === 'drawn')
            //     dispatch(addDrawFeature(response.data.area, MAIN_MAP));
            // dispatch(setFitBoundsFromGeojson(response.data.bounds, { maxZoom: 16 }, MAIN_MAP));
            dispatch(fetchPlanningAlertSuccess(id, response.data));
        }).catch(error => {
            console.log(error, error.response);
            if (axios.isCancel(error)) {
                console.log('cancel');
            } else {
                dispatch(fetchPlanningAlertError(id, error.response));
                console.error(error);
            }
        });
    };
};

export const createPlanningAlertAsync = (projectId: number, form: { name: any; description: any; facetId: any; facetValue: any; geojson: { geometry: any; }; criteria: any; frequency: any; changeType: any; sendEmail: any; sendAppNotification: any; }) => {
    return (dispatch: (arg0: { type: string; planningAlert?: PlanningAlertForm; severity?: string; message?: string; error?: any; }) => void) => {
        dispatch(createPlanningAlert());
        return axios.post(`/api/projects/${projectId}/planning_alerts`, {
            name: form.name,
            description: form.description,
            area_facet_id: form.facetId,
            area_facet_value: form.facetValue,
            geometry: form.geojson.geometry, // may be geojson geometry but should be whole object
            criteria: form.criteria,
            frequency: form.frequency,
            change_type: form.changeType,
            send_email: form.sendEmail,
            send_app_notification: form.sendAppNotification
        }, {
            cancelToken: (createPlanningAlertSource = axios.CancelToken.source()).token
        }).then(response => {
            dispatch(createPlanningAlertSuccess(response.data));
            dispatch(openSnackbar('success', 'Successfully created planning alert'));
        }).catch(error => {
            if (axios.isCancel(error)) {
                console.log('cancel');
            } else {
                dispatch(createPlanningAlertError(error.response));
                console.error(error);
            }
        });
    };
};

export const updatePlanningAlertAsync = (id: number, form: { name: undefined; description: undefined; isActive: undefined; sendAppNotification: undefined; sendEmail: undefined; }) => {
    return (dispatch: (arg0: { type: string; id?: number; planningAlert?: PlanningAlertForm; severity?: string; message?: string; error?: any; }) => void) => {
        dispatch(updatePlanningAlert(id));
        return axios.patch(`/api/planning_alerts/${id}`, {
            ...(form.name !== undefined ? { name: form.name } : {}),
            ...(form.description !== undefined ? { description: form.description } : {}),
            ...(form.isActive !== undefined ? { is_active: form.isActive } : {}),
            ...(form.sendAppNotification !== undefined ? { send_app_notification: form.sendAppNotification } : {}),
            ...(form.sendEmail !== undefined ? { send_email: form.sendEmail } : {})
        }, {
            cancelToken: (updatePlanningAlertSource = axios.CancelToken.source()).token
        }).then(response => {
            dispatch(updatePlanningAlertSuccess(id, response.data));
            dispatch(openSnackbar('success', 'Successfully updated planning alert'));
        }).catch(error => {
            if (axios.isCancel(error)) {
                console.log('cancel');
            } else {
                dispatch(updatePlanningAlertError(id, error.response));
                console.error(error);
            }
        });
    };
};

export const deletePlanningAlertAsync = (id: number) => {
    return (dispatch: (arg0: any) => void) => {
        dispatch(commonDeleteAsync(
            id,
            '/api/planning_alerts',
            deletePlanningAlert,
            deletePlanningAlertSuccess,
            deletePlanningAlertError
        ));
    };
};


export const setCurrentPlanningReport = (id: number) => ({ type: SET_CURRENT_PLANNING_REPORT, id });
export const setCurrentPlanningReportAsync = (id: number) => {
    return (dispatch: (dispatch: any) => Promise<void>) => {
        dispatch(setCurrentPlanningReport(id));
        if (id !== null) { dispatch(fetchPlanningReportAsync(id)); }
    };
};

export const fetchPlanningReportAsync = (id: number) => {
    return (dispatch: (arg0: { type: string; id?: number; planningReport?: PlanningAlertForm; error?: any; }) => void) => {
        dispatch(fetchPlanningReport(id));
        return axios.get(`/api/planning_reports/${id}`, {
            cancelToken: (fetchPlanningReportSource = axios.CancelToken.source()).token
        }).then(response => {
            dispatch(fetchPlanningReportSuccess(response.data));
        }).catch(error => {
            if (axios.isCancel(error)) {
                console.log('cancel');
            } else {
                dispatch(fetchPlanningReportError(id, error.response));
                console.error(error);
            }
        });
    };
};

export const fetchPlanningAlertReportsAsync = (id: number) => {
    return (dispatch: (arg0: { type: string; id: number; planningAlert?: { planningReports: PlanningAlertForm[]; }; error?: any; }) => void) => {
        dispatch(fetchPlanningAlertReports(id));
        return axios.get(`/api/planning_alerts/${id}/reports`, {
            cancelToken: (fetchPlanningAlertReportsSource = axios.CancelToken.source()).token
        }).then(response => {
            dispatch(fetchPlanningAlertReportsSuccess(id, response.data));
        }).catch(error => {
            if (axios.isCancel(error)) {
                console.log('cancel');
            } else {
                dispatch(fetchPlanningAlertReportsError(id, error.response));
                console.error(error);
            }
        });
    };
};